import {Injectable} from '@angular/core';
import {ReportFilterFieldService} from '../../report-filter-field/report-filter-field.service';

@Injectable({
  providedIn: 'root'
})
export class ReportFilterReport004Service {

  constructor() {
  }

  static generate(filters: any, afilters: any[]) {
    ReportFilterFieldService.hasCode(filters, afilters);
    ReportFilterFieldService.hasKind(filters, afilters);
    ReportFilterFieldService.hasDetail(filters, afilters, 'fichaTecnica');
    ReportFilterFieldService.hasAdvertisingAgency(filters, afilters);
    ReportFilterFieldService.hasProvider(filters, afilters);
  }

}
